<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="1000px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="pageloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>Turtų tikrinimas</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 pb-4">
          <v-card-text>
            <v-data-table
              :headers="filteredHeaders"
              :items="itemsList"
              :loading="tableLoading"
              :search="search"
              :footer-props="{
                showFirstLastPage: true,
                showCurrentPage: true,
                itemsPerPageText: 'Rodyti po:',
                itemsPerPageAllText: 'visi',
                itemsPerPageOptions: itemsPerPageOptions,
              }"
              :hide-default-footer="hideFooter"
              :items-per-page="pageSize"
            >
              <template #top>
                <v-toolbar flat>
                  <v-text-field
                    v-model="search"
                    prepend-icon="mdi-magnify"
                    label=""
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
              <template #[`header.taar`]="{ header }">
                {{ header.text }}
                <el-checkbox
                  align-self="center"
                  class="align-center justify-center mt-0"
                  label=""
                  v-model="headerCheckTaar"
                  @click.native.stop="checkAllTaar()"
                />
              </template>
              <template #[`header.stsr`]="{ header }">
                {{ header.text }}
                <el-checkbox
                  class="align-center justify-center mt-0"
                  label=""
                  v-model="headerCheckStsr"
                  @click.native.stop="checkAllStsr()"
                />
              </template>
              <template #[`header.ntr`]="{ header }">
                {{ header.text }}
                <el-checkbox
                  class="align-center justify-center mt-0"
                  label=""
                  v-model="headerCheckNtr"
                  @click.native.stop="checkAllNtr()"
                />
              </template>
              <template #[`item.taar`]="{ item }">
                <div class="text-center mb-2">
                  <el-checkbox
                    v-if="item.isTaar"
                    label=" "
                    v-model="checkTaar"
                    :checkValue="item.tur_id"
                    :key="`taar${item.tur_id}`"
                  />
                </div>
              </template>
              <template #[`item.stsr`]="{ item }">
                <div class="text-center mb-2">
                  <el-checkbox
                    v-if="item.isStsr"
                    label=" "
                    v-model="checkStsr"
                    :checkValue="item.tur_id"
                    :key="`stsr${item.tur_id}`"
                  />
                </div>
              </template>
              <template #[`item.ntr`]="{ item }">
                <div class="text-center mb-2">
                  <el-checkbox
                    v-if="item.isNtr"
                    label=" "
                    v-model="checkNtr"
                    :checkValue="item.tur_id"
                    :key="`ntr${item.tur_id}`"
                  />
                </div>
              </template>
              <template #[`body.append`]>
                <tr>
                  <td colspan="7" class="text-end">
                    <strong>Kaina iš viso:</strong>
                  </td>
                  <td class="text-center">{{ visoVerte }}</td>
                </tr>
              </template>
              <template slot="loading">
                Kraunasi...
              </template>
              <template slot="no-results">
                Duomenų nėra
              </template>
              <template slot="no-data">
                Duomenų nėra
              </template>
              <template #[`footer.page-text`]="props">
                Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
                {{ props.itemsLength }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native="cancelData()">
          Atšaukti
        </el-button>
        <el-button
          primary
          :disabled="!enableSubmit"
          @click.native.stop="openConfirm()"
        >
          Tikrinti
        </el-button>
      </v-card-actions>
    </v-card>

    <modal-confirm
      title="Turtų tikrinimas"
      text="Ar tikrai norite atlikti tikrinimą?"
      action="TurtasCheck"
      v-model="showConfirm"
      @confirmTurtasCheck="saveData"
      @cancelConfirm="cancelData"
    />
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import math from '../../mixins/math'
import ModalConfirm from './ModalConfirm'

export default {
  name: 'ModalTurtasCheck',
  props: {
    value: Boolean,
  },
  components: {
    ModalConfirm,
  },
  mixins: [math],
  data() {
    return {
      pageloading: false,
      loading: false,
      tableLoading: false,
      turtai: [],
      checkTaar: [],
      checkStsr: [],
      checkNtr: [],
      headerCheckTaar: false,
      headerCheckStsr: false,
      headerCheckNtr: false,
      showConfirm: false,
      search: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
    }
  },
  computed: {
    ...mapGetters(['objektasID']),
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    headers() {
      return [
        {
          text: 'Turto ID',
          align: 'start',
          value: 'tur_identifikatorius',
        },
        {
          text: 'Turto rūšis',
          align: 'start',
          value: 'rusis',
        },
        {
          text: 'TAAR',
          align: 'start',
          sortable: false,
          value: 'taar',
        },
        {
          text: 'Kaina',
          align: 'center',
          sortable: false,
          value: 'kainaTaar',
        },
        {
          text: 'STSR',
          align: 'start',
          sortable: false,
          value: 'stsr',
        },
        {
          text: 'Kaina',
          align: 'center',
          sortable: false,
          value: 'kainaStsr',
        },
        {
          text: 'NTR',
          align: 'start',
          sortable: false,
          value: 'ntr',
        },
        {
          text: 'Kaina',
          align: 'center',
          sortable: false,
          value: 'kainaNtr',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.turtai.map(item => {
        item.isTaar = item.kaina_taar > 0
        item.isStsr = item.kaina_stsr > 0
        item.isNtr = item.kaina_ntr > 0

        item.kainaTaar = item.isTaar ? this.moneyformat(item.kaina_taar) : ''
        item.kainaStsr = item.isStsr ? this.moneyformat(item.kaina_stsr) : ''
        item.kainaNtr = item.isNtr ? this.moneyformat(item.kaina_ntr) : ''
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    visoVerte() {
      let visoTaar = this.itemsList
        .map(item =>
          item.kaina_taar > 0 && this.checkTaar.includes(item.tur_id)
            ? item.kaina_taar
            : 0
        )
        .reduce((accumulator, currentValue) => {
          return accumulator + currentValue
        }, 0)
      let visoStsr = this.itemsList
        .map(item =>
          item.kaina_stsr > 0 && this.checkStsr.includes(item.tur_id)
            ? item.kaina_stsr
            : 0
        )
        .reduce((accumulator, currentValue) => {
          return accumulator + currentValue
        }, 0)
      let visoNtr = this.itemsList
        .map(item =>
          item.kaina_ntr > 0 && this.checkNtr.includes(item.tur_id)
            ? item.kaina_ntr
            : 0
        )
        .reduce((accumulator, currentValue) => {
          return accumulator + currentValue
        }, 0)

      return this.moneyformat(visoTaar + visoStsr + visoNtr)
    },
    enableSubmit() {
      return (
        this.checkTaar.length > 0 ||
        this.checkStsr.length > 0 ||
        this.checkNtr.length > 0
      )
    },
  },
  watch: {
    showModal(val) {
      if (val) {
        this.getData()
      }
    },
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true
      this.tableLoading = true
      this.$axios
        .get(`objektas/${this.objektasID}/tikrinimas-turtas`)
        .then(res => {
          this.turtai = res.data.turtai
          this.headerCheckTaar = false
          this.headerCheckStsr = false
          this.headerCheckNtr = false
          this.checkTaar = []
          this.checkStsr = []
          this.checkNtr = []
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.tableLoading = false
          this.loading = false
          this.pageloading = false
        })
    },
    saveData() {
      this.loading = true
      const data = {
        turtai: this.getRegistrasData(),
      }

      this.$axios
        .post(`objektas/${this.objektasID}/tikrinimas-turtas`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.$emit('savedData')
          this.closeModal()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getRegistrasData() {
      return this.itemsList.map(item => {
        return {
          tur_id: item.tur_id,
          taar: this.checkTaar.includes(item.tur_id),
          stsr: this.checkStsr.includes(item.tur_id),
          ntr: this.checkNtr.includes(item.tur_id),
        }
      })
    },
    cancelData() {
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.closeModal()
    },
    openConfirm() {
      this.showConfirm = true
    },
    checkAllTaar() {
      this.checkTaar = []
      if (this.headerCheckTaar) {
        this.itemsList.forEach(item => {
          if (item.isTaar) {
            this.checkTaar.push(item.tur_id)
          }
        })
      }
    },
    checkAllStsr() {
      this.checkStsr = []
      if (this.headerCheckStsr) {
        this.itemsList.forEach(item => {
          if (item.isStsr) {
            this.checkStsr.push(item.tur_id)
          }
        })
      }
    },
    checkAllNtr() {
      this.checkNtr = []
      if (this.headerCheckNtr) {
        this.itemsList.forEach(item => {
          if (item.isNtr) {
            this.checkNtr.push(item.tur_id)
          }
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
